/**
 * Merged sender/text lists for Edit Sent (campaign + drops + local).
 */

import { useMemo } from 'react';

import type { PreparedDrop } from '@/features/smswiser-campaigns/types/workspace.types';

function uniqueMerge<T>(a: T[], b: T[]): T[] {
  return Array.from(new Set([...a, ...b]));
}

export function useEditSentDropMergedLists(
  drops: PreparedDrop[],
  senderNames: string[],
  smsTexts: string[],
  localSenders: string[],
  localTexts: string[],
) {
  const mergedSenders = useMemo(() => {
    const all: string[] = [];
    for (const d of drops) if (d.senderNames?.length) all.push(...d.senderNames);
    return Array.from(new Set(all));
  }, [drops]);
  const mergedTexts = useMemo(() => {
    const all: string[] = [];
    for (const d of drops) if (d.smsTexts?.length) all.push(...d.smsTexts);
    return Array.from(new Set(all));
  }, [drops]);
  const sendersList = useMemo(
    () => uniqueMerge(uniqueMerge(senderNames, mergedSenders), localSenders),
    [senderNames, mergedSenders, localSenders],
  );
  const textsList = useMemo(
    () => uniqueMerge(uniqueMerge(smsTexts, mergedTexts), localTexts),
    [smsTexts, mergedTexts, localTexts],
  );
  return { sendersList, textsList };
}
